import { Button } from "./ButtonUtils"


function SubmitButton({text, classes, ...rest}) {
  return (
    <Button type="submit" className={` w-full p-5 rounded-full ${classes} disabled:bg-green-100`} {...rest}>{text}</Button>
  )
}

export default SubmitButton